'use strict';
const Action = require('process/domain/entity/action/index');

module.exports = Action.extend({
    canAddState: function() {
        return true;
    },

    getShape: function() {
        return 'diamond';
    },

    getSize: function() {
        return {
            width: 384,
            height: 256
        };
    },

    getConfiguration: function() {
        return new Promise((resolve, reject) => {
            if(this.get('_configuration')) {
                resolve(this.get('_configuration'));
            }
            const configId = this.get('configuration');
            ConfigurationRepository.find(this.getProject())
                .getConfiguration(configId).then(configuration => {
                this.set({_configuration: configuration});
                resolve(this.get('_configuration'));
            })
        });
    }
});



// WEBPACK FOOTER //
// ./process/domain/entity/action/decision.js